<template>
  <div style="background: #eee">
    <van-sticky :z-index="99">
      <van-nav-bar title="结算管理" left-text="返回" left-arrow @click-left="goback" />
      <van-tabs v-model="activeName" swipeable @click="tabChange">
        <van-tab v-for="item in orderTabs" :key="item.type" :title="item.title" :name="item.type" />
      </van-tabs>
      <van-row>
        <van-col span="24" class="statistics-container">
          <span v-if="showOption.includes('totalAmount')">总金额: {{ totalAmount }}</span>
          <span v-if="showOption.includes('paidAmount')">已付金额: {{ paidAmount }}</span>
          <span v-if="showOption.includes('deductionAmount')">抵扣金额: {{ deductionAmount }}</span>
          <span v-if="showOption.includes('remainingAmount')">待付金额: {{ remainingAmount }}</span>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="20">
          <van-field readonly clickable name="picker" label-width="8rem" :value="settlementBatchName" label="选择结算批次名称"
            placeholder="选择结算批次名称" @click="showPicker = true" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
          </van-popup>
        </van-col>
        <van-col span="4">
          <van-button type="default" style="color: red; width: 100%; border: 0px; padding-right: 0px"
            @click="onClear()">清空</van-button>
        </van-col>
      </van-row>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" offset="300" @load="onLoad">
      <van-cell-group v-for="(item, index) in orderList" :key="index" style="margin: 1.2rem; text-align: left" inset>
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
          {{ item.settlementBatchName }}
        </div>
        <div v-show="activeName === 0" style="
            width: 0;
            height: 0;
            border: 4rem solid transparent;
            border-top: none;
            border-right-color: #ee0a24;
            float: right;
            margin-top: -3rem;
            margin-right: 0.8rem;
            position: relative;
            margin-bottom: 0.4rem;
          ">
          <span style="
              position: absolute;
              width: 3rem;
              height: 4rem;
              line-height: 2rem;
              margin-left: 1.4rem;
              color: #fff;
              font-size: 0.8rem;
            ">待确认</span>
        </div>
        <div v-show="activeName === 1" style="
            width: 0;
            height: 0;
            border: 4rem solid transparent;
            border-top: none;
            border-right-color: #e96725;
            float: right;
            margin-top: -3rem;
            margin-right: 0.8rem;
            position: relative;
            margin-bottom: 0.4rem;
          ">
          <span style="
              position: absolute;
              width: 3rem;
              height: 4rem;
              line-height: 2rem;
              margin-left: 1.4rem;
              color: #fff;
              font-size: 0.8rem;
            ">付款中</span>
        </div>
        <div v-show="activeName === 2" style="
            width: 0;
            height: 0;
            border: 4rem solid transparent;
            border-top: none;
            border-right-color: green;
            float: right;
            margin-top: -3rem;
            margin-right: 0.8rem;
            position: relative;
            margin-bottom: 0.4rem;
          ">
          <span style="
              position: absolute;
              width: 3rem;
              height: 4rem;
              line-height: 2rem;
              margin-left: 1.4rem;
              color: #fff;
              font-size: 0.8rem;
            ">已支付</span>
        </div>
        <!-- <van-cell title="结算批次名称" :value="item.settlementBatchName" /> -->
        <van-cell title="总金额" :value="item.totalAmount" />
        <van-cell title="已付金额" v-if="item.paidAmount == 0" :value="item.paidAmount" is-link />
        <van-cell v-else title="已付金额" :value="item.paidAmount" value-class="text-color" is-link
          @click="seePayRecord(item)" />

        <van-cell title="抵扣金额" v-if="!item.deductionAmount" :value="item.deductionAmount" is-link />
        <van-cell v-else title="抵扣金额" :value="item.deductionAmount" value-class="text-color"
          @click="seeDetail(item, '/deduction-records')" is-link />
        <van-cell title="剩余金额" :value="item.remainingAmount" />
        <van-divider :style="{ borderColor: '#000000', padding: '0 16px' }">各项明细</van-divider>
        <van-cell title="安装费用" v-if="item.installFee > 0" is-link :value="item.installFee"
          @click="seeDetail(item, '/settlement/install')" value-class="text-color" />
        <van-cell v-else title="安装费用" is-link :value="item.installFee" />
        <van-cell title="增项提成" v-if="item.commissionFee && item.commissionFee > 0" is-link :value="item.commissionFee"
          @click="seeDetail(item, '/settlement/commission')" value-class="text-color" />
        <van-cell v-else-if="item.commissionFee !== undefined && item.commissionFee !== null" title="增项提成" :value="item.commissionFee || 0" />
        <van-cell title="增项被提成" :value="item.installerCommissionFee || 0"  is-link />
        <van-cell title="正负激励金额" v-if="!item.incentiveFee" is-link :value="item.incentiveFee" />
        <van-cell title="正负激励金额" v-else is-link :value="item.incentiveFee"
          @click="seeDetail(item, '/settlement/motivate')" value-class="text-color" />

        <van-cell title="管理费用" is-link v-show="item.manageFee > 0" :value="item.manageFee"
          @click="seeDetail(item, 'settlement/manage')" value-class="text-color" />
        <van-cell v-if="item.materialFee == 0" title="物料费用" is-link :value="item.materialFee" />
        <van-cell v-else title="物料费用" is-link :value="'-' + item.materialFee"
          @click="seeDetail(item, '/settlement/material')" value-class="text-color" />
        <van-cell v-if="item.otherFee == 0" title="其他费用" is-link :value="item.otherFee" />
        <van-cell v-else title="其他费用" is-link :value="item.otherFee" @click="seeDetail(item, '/settlement/other')"
          value-class="text-color" />
        <van-cell title="结算师傅名称" :value="item.responsibleUserIdStr" />
        <van-cell title="公司名称" :value="item.companyIdStr" />
        <van-cell title="创建时间" :value="item.createTime" />
        <van-cell title="创建人" :value="item.createdByStr" />
        <van-cell title="修改时间" :value="item.updateTime" />
        <van-cell title="修改人" :value="item.updatedByStr" />
        <van-row style="padding: 1rem">
          <van-col span="5.5" v-show="activeName === 0">
            <van-button type="default" size="small" @click="showRemarkDialog(item)"
              v-show="authorization('/home-admin/settlementManage/h5/confirm')">结算确认</van-button>
          </van-col>
          <van-col span="5.5" v-show="[1, 2].includes(activeName) && item.paidAmount > 0">
            <van-button type="default" size="small" @click="seePayRecord(item)">查看支付记录</van-button>
          </van-col>
        </van-row>
      </van-cell-group>
    </van-list>
    <van-dialog v-model="showdialog" title="结算确认" show-cancel-button @confirm="confirmSettlement"
      @cancel="showdialog = false">
      <span style="font-size: 16px; font-weight: 700; line-height: 70px">结算确认后，将进行支付流程</span>
    </van-dialog>
  </div>
</template>
<script>
import { authorization } from "@/authorization/authorization";
export default {
  name: "Settlement",
  data() {
    return {
      activeName:
        this.$route.query.type === undefined
          ? 0
          : Number(this.$route.query.type), // Default active tab name
      orderTabs: [
        {
          type: 3,
          title: "预结算列表",
          color: "#7af",
          url: "/v1/web/settlement-manage/settlement-order/h5/listDraft",
        },
        {
          type: 0,
          title: "待确认结算单",
          color: "#7af",
          url: "/v1/web/settlement-manage/settlement-order/h5/listPending",
        },
        {
          type: 1,
          title: "付款中结算单",
          color: "#fa0",
          url: "/v1/web/settlement-manage/settlement-order/h5/listUnpaid",
        },
        {
          type: 2,
          title: "已支付结算单",
          color: "#f00",
          url: "/v1/web/settlement-manage/settlement-order/h5/listPaid",
        },
      ],
      params: {
        content: "", // Search content
      },
      loading: false,
      finished: false,
      orderList: [],
      total: 0,
      showdialog: false,
      remarks: "",
      currentData: {},
      page: 1,
      columns: [],
      showPicker: false,
      settlementBatchName: "",
      statistics: {
        totalAmount: 0,
        paidAmount: 0,
        deductionAmount: 0,
        remainingAmount: 0,
      },
    };
  },
  computed: {
    totalAmount() {
      return this.statistics.totalAmount || 0;
    },
    paidAmount() {
      return this.statistics.paidAmount || 0;
    },
    deductionAmount() {
      return this.statistics.deductionAmount || 0;
    },
    remainingAmount() {
      return this.statistics.remainingAmount || 0;
    },
    showOption() {
      // 不是已支付
      return this.activeName !== 2 ? [
        "totalAmount",
        "paidAmount",
        "deductionAmount",
        "remainingAmount",
      ] : ["paidAmount"];
    },
  },
  created() {
    this.getSettlementList();
  },
  methods: {
    // Your methods here
    authorization,
    onClear() {
      this.settlementBatchName = "";
      this.page = 1;
      const data = this.orderTabs.find((item) => item.type === this.activeName);
      this.queryData(data.type, data.url);
    },
    onConfirm(value) {
      this.settlementBatchName = value;
      this.showPicker = false;
      const data = this.orderTabs.find((item) => item.type === this.activeName);
      this.queryData(data.type, data.url);
    },
    getSettlementList() {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementH5?status=" + this.activeName,
      }).then((res) => {
        this.columns = res.data.data;
      });
    },
    goback() {
      //返回上一页
      this.$router.push("/");
    },
    seeDetail(item, url) {
      this.$router.push({
        path: url,
        query: {
          id: item.id,
          settlementBatchName: item.settlementBatchName,
          responsibleUserId: item.responsibleUserId,
        },
      });
    },
    showRemarkDialog(item) {
      this.currentData = item;
      this.showdialog = true;
    },
    confirmSettlement() {
      this.axios({
        url: `/v1/web/settlement-manage/settlement-order/h5/confirm/${this.currentData.id}`,
        method: "post",
        data: {
          remarks: this.remarks,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$toast.success(res.data.message);
          this.queryData(
            this.activeName,
            this.orderTabs.find((item) => item.type === this.activeName).url
          );
        } else {
          this.$toast.fail(res.data.message);
        }
        this.showdialog = false;
        this.remarks = "";
      });
    },
    tabChange(name) {
      this.$router.push({ path: "/SettlementList", query: { type: name } });
      const data = this.orderTabs.find((item) => item.type === name);
      this.orderList = [];
      this.page = 1;
      this.settlementBatchName = "";
      this.queryData(data.type, data.url);
      this.getSettlementList();
    },
    onLoad() {
      // 异步更新数据
      const data = this.orderTabs.find((item) => item.type === this.activeName);
      this.queryData(data.type, data.url);
    },
    queryData(name, url) {
      const data = {
        queryInfoParams: {
          status: name,
          settlementBatchName: this.settlementBatchName,
        },
        page: this.page,
        size: 10,
      };
      this.axios({
        url: url,
        method: "post",
        data,
      }).then((res) => {
        this.statistics = res.data.data.extend;
        if (this.page === 1) {
          this.orderList = res.data.data.list;
        } else {
          this.orderList = [...res.data.data.list, ...this.orderList];
        }
        this.total = res.data.data.total;
        this.loading = false;
        if (this.orderList.length === this.total) {
          this.finished = true;
        } else {
          this.page++;
        }
      });
    },
    seePayRecord(row) {
      this.$router.push({ path: "/payment-records", query: { id: row.id } });
    },
  },
};
</script>

<style scoped>
.text-color {
  color: #3a96dd;
  font-weight: 700;
  text-decoration: underline;
}

.statistics-container {
  background-color: #fff;
  text-align: start;
  padding-left: 0.95rem;
}

.statistics-container span {
  font-size: 0.9rem;
  color: #333;
  margin-right: 0.5rem;
}
</style>
